import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./slices/authSlice";
import userReducer from "./slices/userSlice";
import { baseApi } from "./api/baseApi";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // Only persist auth slice (token, user, isAuthenticated)
};

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }).concat(baseApi.middleware),
});

export const persistor = persistStore(store);

// Export types after store is created to avoid circular dependency
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

